import { HttpParams } from '@angular/common/http/src/params';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PlameAbsence } from '../entities/plame-absence';

@Injectable()
export class PlameAbsenceService extends BaseCrudService<PlameAbsence> {

    public uri = '/api/plameAbsence/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance PlameAbsenceService');
    }

    buildSentence(entity?: PlameAbsence, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                    + QueryOperator.Contain + entity.name
                    + QueryOperator.Split : QueryOperator.Empty
            );

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }

        this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'code');
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/plame-absence.service.ts